'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import { withRef } from '@/lib/with-ref';
import Animate from '@/components/animations/Animate';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import { type ButtonElement, type ButtonProps, buttonVariants } from './types';

const Button = withRef<ButtonElement, ButtonProps>(
  (
    {
      useDefaultAnimation = true,
      className,
      variant,
      size,
      asChild = false,
      responsive = {},
      children,
      ...props
    },
    ref,
  ) => {
    const defaultAnimation = useDefaultAnimation
      ? {
          whileHover: { scale: 1.05 },
          whileTap: { scale: 0.9 },
        }
      : {};

    return (
      <ResponsiveWrapper responsive={responsive}>
        <Animate
          // ref={ref}
          as={asChild ? undefined : 'button'}
          asChild={asChild}
          className={cn(buttonVariants({ className, size, variant }))}
          {...defaultAnimation}
          {...props}
        >
          {children}
        </Animate>
      </ResponsiveWrapper>
    );
  },
);

Button.displayName = 'Button';

export default React.memo(Button);
